import { EnvironmentSmataInfo } from './environment.model';

export const environment: EnvironmentSmataInfo = {
  name: 'Netstrata',
  production: true,
  envName: 'dev',
  apiUrl: 'https://api.ss-edge-dev.cloud.netstrata.com.au',
};
